module.exports = __webpack_public_path__ + "img/c1.1642cf7e.png";